<app-icon *ngIf="!isOpen" class="icon icon-btn" name="plus"></app-icon>
<app-icon *ngIf="isOpen" class="icon icon-btn" name="minus"></app-icon>
